import { deepMerge } from '@empathybroker/deep-merge';
import { ConfigState, EmpathyXConfig, FacetConfig, FacetsGroupsConfig } from '../../../models';
import { Dictionary } from '../../../utils';
import { CONFIG_GETTERS_KEYS } from '../../config/config.const';
import { ConfigGetter } from '../config.interfaces';

export class FacetsGetter implements ConfigGetter {
  getters = {
    /*
     This getter returns the facets configuration outside of the groups.
     */
    [CONFIG_GETTERS_KEYS.facets]: (configState: ConfigState, getters: any): Dictionary<FacetConfig> => {
      const config: EmpathyXConfig = getters[CONFIG_GETTERS_KEYS.config];
      const defaultFacetConfig = config.facets.default.facet;
      const facetsConfig = config.facets.facets;
      return Object.entries(facetsConfig).reduce<Dictionary<FacetConfig>>((mergedFacetsConfig, [facetName, facetConfig]) => {
        mergedFacetsConfig[facetName] = deepMerge({}, defaultFacetConfig, facetConfig);
        return mergedFacetsConfig;
      }, {});
    },
    /*
     * Returns a set containing the facet names that are configured inside all facets groups
     */
    [CONFIG_GETTERS_KEYS.configuredFacets]: (configState: ConfigState, getters: any): Set<string> => {
      const facetsGroupsConfig: FacetsGroupsConfig = getters[CONFIG_GETTERS_KEYS.facetsGroups];
      return Object.values(facetsGroupsConfig)
        .reduce((configuredFacets, { facets }) => this.addKeysToSet(configuredFacets, facets), new Set<string>());
    }
  };

  protected addKeysToSet(set: Set<string>, obj: {}): Set<string> {
    Object.keys(obj).forEach(key => set.add(key));
    return set;
  }
}
